<template>
  <w-td align="center" justify="space-e">
    <w-button
      v-if="canMoveUp"
      variant="ghost"
      size="sm"
      icon="move_up"
      aria-label="Przesuń wiersz w górę"
      @click="moveRowUp"
    />

    <w-button
      v-if="canMoveDown"
      variant="ghost"
      size="sm"
      icon="move_down"
      aria-label="Przesuń wiersz w dół"
      @click="moveRowDown"
    />

    <w-button
      v-if="deleteRow"
      variant="ghost"
      size="sm"
      color="danger"
      icon="delete"
      aria-label="Usuń wiersz"
      @click="removeRow"
    />
  </w-td>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { confirmService } from '../../services/confirm.service';

const {
  model,
  confirmDeleteMessage = 'Czy jesteś pewien/a, że chcesz usunąć ten wiersz?',
  deleteRow = true,
  moveUp = undefined,
  moveDown = undefined,
} = defineProps<{
  /**
   * Model pojedynczego wiersza tablicy, który będzie modyfikowany przez przyciski akcji.
   */
  model: any;

  /**
   * Wiadomość wyświetlana w oknie potwierdzenia przed usunięciem wiersza. Domyślnie "Czy jesteś pewien/a, że chcesz usunąć ten wiersz?".
   */
  confirmDeleteMessage?: string;

  /**
   * Flaga określająca, czy przycisk usuwania ma być widoczny.
   */
  deleteRow?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w górę ma być widoczny.
   */
  moveUp?: boolean;

  /**
   * Flaga określająca, czy przycisk przesuwania wiersza w dół ma być widoczny.
   */
  moveDown?: boolean;
}>();

const index = computed(() =>
  model.$parent.$items.findIndex((item: { $item: any }) => item.$item === model),
);
const itemsLength = computed(() => model.$parent.$items.length);

const canMoveUp = computed(() => (moveUp !== undefined ? moveUp : index.value > 0));
const canMoveDown = computed(() =>
  moveDown !== undefined ? moveDown : index.value < itemsLength.value - 1,
);

const emit = defineEmits<{
  rowDeleted: [];
  rowMovedUp: [model: any];
  rowMovedDown: [model: any];
}>();

function moveRowUp() {
  model.$moveUp();
  emit('rowMovedUp', model);
}

function moveRowDown() {
  model.$moveDown();
  emit('rowMovedDown', model);
}

function removeRow() {
  confirmService
    .confirm(confirmDeleteMessage)
    .then(() => {
      model.$removeRow();
      emit('rowDeleted');
    })
    .catch(() => {
      // Użytkownik anulował usunięcie
    });
}
</script>
